import dayjs from "dayjs";

/** Преобразует датувремя в строку для передачи даты на сервер 
 * @param {Dayjs} value Дата время
 * 
*/
export const strDate2Server = value => {
  if (!value) return null;
  return dayjs(value).format("YYYY-MM-DD");
}

export const fmtDateTimeFull = value => {
  return value && dayjs(value).format("DD.MM.YYYY HH:mm:ss");
}

export const fmtDate = value => {
  return value && dayjs(value).format("DD.MM.YYYY");
}

export const fmtTime = value => {
  return value && dayjs(value).format("HH:mm");
}

// Преобразование строки вида HH:mm:ss в объекта dayjs
export const cnvString2Time = (value) => {
  return value && dayjs(value, "HH:mm:ss", true);
}

export const fmtTimeHM = (value) => {
  return value && dayjs(value).format("HH:mm");
}
